<div class="unsaved-dialog text-center">
    <h1 >{{title}}</h1>
    <div >
        <p>{{message}}</p>
    </div>
    <div align="center">
            <button color="primary" class="btn btn-fill common-button me-2" [mat-dialog-close]="false">{{errorMessage.Close}}</button>
            <button color="warn" class="btn btn-border common-button"  [mat-dialog-close]="true" cdkFocusInitial>{{errorMessage.Notclose}}</button>
    </div>
</div>